import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { manageSiteSettings } from "src/actions/site";
import Section from "src/components/Shared/Containers/Section";
import { useAsyncAction } from "src/hooks/useAsyncAction";
import { useHasChanges } from "src/hooks/useHasChanges";
import SettingsContainer from "./SettingsContainer";

const UserSettings = ({ site, manageSiteSettings }) => {
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);

  const {
    loading: twoFactorTimeframeButtonDisabled,
    success: twoFactorSuccess,
    execute: handleTwoFactorSubmit,
  } = useAsyncAction({
    onSuccess: () => {},
    onError: (error) => toast.error(error.message),
  });

  const onTwoFactorTimeframeSubmit = () =>
    handleTwoFactorSubmit(async () => {
      await manageSiteSettings({
        two_factor_enabled: twoFactorEnabled,
      });
    });

  const initailizeTwoFactorFieldsValue = () => {
    setTwoFactorEnabled(site.two_factor_enabled || false);
  };

  useEffect(() => {
    if (site?._id) {
      initailizeTwoFactorFieldsValue();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site]);

  // Two Factor Fields
  const currentTwoFactor = {
    two_factor_enabled: twoFactorEnabled,
  };

  const originalTwoFactor = {
    two_factor_enabled: site.two_factor_enabled,
  };

  const hasTwoFactorChanges = useHasChanges(currentTwoFactor, originalTwoFactor);

  return (
    <>
      <Section>
        <div className="grid w-full gap-y-4">
          <SettingsContainer
            defaultTitle={{
              title: "Enable Two-Factor Authentication",
              subTitle: "Require email verification for login attempts.",
              inputFirstTitle: "Email 2FA is required after",
              inputSecondTitle: "without a login.",
            }}
            isSuccess={twoFactorSuccess}
            isEnabled={twoFactorEnabled}
            setIsEnabled={setTwoFactorEnabled}
            isButtonDisabled={twoFactorTimeframeButtonDisabled}
            onSubmit={onTwoFactorTimeframeSubmit}
            onCancel={initailizeTwoFactorFieldsValue}
            site={site}
            hasChanges={hasTwoFactorChanges}
          />
        </div>
      </Section>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    site: state.site,
    me: state.auth.user,
  };
};

export default connect(mapStateToProps, { manageSiteSettings })(UserSettings);
